import { render, staticRenderFns } from "./EnglishLayer.vue?vue&type=template&id=2838c220&"
import script from "./EnglishLayer.vue?vue&type=script&lang=js&"
export * from "./EnglishLayer.vue?vue&type=script&lang=js&"
import style0 from "./EnglishLayer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports